export default __webpack_public_path__ + "static/media/36I-114295_-20840_0.07051214.jpg";